import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditableFieldModule } from '../editable-field';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { FieldErrorDisplayModule } from '../field-error-display';
import { PictureModule } from '../picture';
import { BudgetFooterComponent } from './budget-footer.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectSearchModule } from '../select-search/select-search.module';
import { TranslateModule } from '@ngx-translate/core';
import { PermissionsModule } from '../permissions';

@NgModule({
  declarations: [BudgetFooterComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    EditableFieldModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatCardModule,
    FieldErrorDisplayModule,
    NgSelectModule,
    FormsModule,
    SelectSearchModule,
    PermissionsModule,
  ],
  exports: [BudgetFooterComponent],
})
export class BudgetFooterModule {}
